import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, styled, Theme } from '@streem/ui-react';
import { MemberInformation } from '../../../reservation_call_details/member_information';
import { CallDetailItems } from '../../../reservation_call_details/call_detail_items';
export const InCallCallDetails = ({ room, isTrayOpen }) => {
    const customer = room?.callDetail?.customer ?? {};
    const items = room?.callDetail?.items ?? [];
    const groupName = room?.reservationGroup?.name ?? '';
    const titleFontSize = Theme.text.size.medium;
    const itemFontSize = Theme.text.size.medium;
    const itemTitleFontSize = Theme.text.size.notQuiteAllTheWayMediumLarge;
    const keyValueStyles = { fontSize: itemFontSize };
    const keyValueTileStyles = { bottomPadding: '1.0rem' };
    return (_jsxs(Wrapper, { children: [_jsx(MemberInformation, { customer: customer, columnsPerRow: 1, dataIdPrefix: "in-call-call-details", keyValueStyles: keyValueStyles, keyValueTileStyles: keyValueTileStyles, memberInformationStyles: { titleFontSize }, isTrayOpen: isTrayOpen, useDisplayAsPillCapabilityYn: true }), _jsx(CallDetailItems, { trade: groupName, items: items, maxItemsPerRow: 1, dataIdPrefix: "in-call-call-details", keyValueStyles: keyValueStyles, keyValueTitleStyles: { fontSize: itemTitleFontSize }, keyValueTileStyles: keyValueTileStyles, callDetailItemStyles: { titleFontSize } })] }));
};
const Wrapper = styled(Column)({
    rowGap: '1.5rem',
    alignItems: 'space-between',
    position: 'relative',
    // want 1.5rem between the tabs and the content.  The tabs have 1rem bottom padding and this
    //     component's container has 1rem top padding.  So we need to move this up .5rem.
    top: '-.5rem',
});
//# sourceMappingURL=in_call_call_details.js.map